import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Observable, timer } from 'rxjs';
import { takeWhile, map, finalize } from 'rxjs/operators';
import { AuthService } from 'src/app/providers/auth/auth.service';

export interface DialogData {
  header: string;
  message?: string;
  buttons: [{
    label: string,
    role?: string,
    handler?: Function
  }];
}

@Component({
  selector: 'app-dialog-idle-logout',
  templateUrl: './dialog-idle-logout.component.html',
  styleUrls: ['./dialog-idle-logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogIdleLogoutComponent implements OnInit, OnDestroy {
  @Input() idleTime: number;
  @Input() logoutTime: number;

  timeRemaining$: Observable<any>;
  idleTimeInMinutes:number =  0;
  logoutTimeInMinutes: number = 5 * 1000;
  refreshCount: number = 0;
  
  constructor(
    private auth: AuthService,
    private cdr: ChangeDetectorRef,
    private modalCtrl: ModalController
    ) {}

  ngOnInit() {
    
    this.idleTimeInMinutes = this.idleTime;
    this.logoutTimeInMinutes = (this.logoutTime || this.idleTime) * 60;
    // Refresh the users token when the popup prompt appaers
    this.auth.userRefreshToken().catch(() => {});

    this.timeRemaining$ = timer(0, 1000).pipe(map((n: number) => (this.logoutTimeInMinutes - n) * 1000),
      takeWhile((n: number) => n >= 0),
      // optional
      finalize(() => {
        // console.log('timeRemaining$ finalize')
        // debugger;
        this.modalCtrl.dismiss('timeRemaining$ finalize', 'confirm');
      })
    );

  }

  logOut() {
    // this.auth.setIdleRefreshCount(1);
    this.auth.logout();
    this.modalCtrl.dismiss('logout', 'confirm');;
  }

  reAuthenticate() {
    this.auth.userRefreshToken().then(() => this.modalCtrl.dismiss('Continue', 'confirm')).catch(() => this.modalCtrl.dismiss('Continue', 'confirm'));
  }

  ngOnDestroy(): void {
    console.log('DialogIdleLogoutComponent ngOnDestroy')
  }

}
